import { render, staticRenderFns } from "./FilterStats.vue?vue&type=template&id=8cb8cb54&scoped=true"
import script from "./FilterStats.vue?vue&type=script&lang=js"
export * from "./FilterStats.vue?vue&type=script&lang=js"
import style0 from "./FilterStats.vue?vue&type=style&index=0&id=8cb8cb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb8cb54",
  null
  
)

export default component.exports